import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=40ff99aa&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40ff99aa')) {
      api.createRecord('40ff99aa', component.options)
    } else {
      api.reload('40ff99aa', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=40ff99aa&", function () {
      api.rerender('40ff99aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2srQr0tepw73l/JS/videoIframe.vue"
export default component.exports